import { CardContainer, useScreenWidth } from "@msys/ui";
import { Box, Typography } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { RestrictedByOrganisationPermissionWithDebug } from "../../../auth/RestrictedByOrganisationPermission.js";
import { useUserData } from "../../../auth/useUserData.js";
import { CategoriesChips } from "../../categories/CategoriesLabeledValue.js";
import { ModifyOrganisationProfileCategoriesButton } from "../buttons/ModifyOrganisationProfileCategoriesButton.js";
import { OrganisationPublicServicesBox_OrganisationProfileFragment } from "./OrganisationPublicServicesBox.generated.js";

interface Props {
  organisationProfile: OrganisationPublicServicesBox_OrganisationProfileFragment;
  canEdit: boolean;
}

export const OrganisationPublicServicesBox = ({
  organisationProfile,
  canEdit,
}: Props) => {
  const viewer = useUserData().currentUser!;
  const { t } = useTranslate(["OrganisationPublicProfile", "Global"]);
  const { isMaxPhone } = useScreenWidth();

  return (
    <CardContainer
      title={t("Services", {
        ns: "OrganisationPublicProfile",
      })}
      itemCount={organisationProfile.categories.length}
      ActionButton={
        canEdit && (
          <RestrictedByOrganisationPermissionWithDebug permission="MANAGE_ORG">
            {viewer.organisation.id === organisationProfile.organisation.id && (
              <ModifyOrganisationProfileCategoriesButton
                slug={organisationProfile.slug}
                categories={organisationProfile.categories}
              />
            )}
          </RestrictedByOrganisationPermissionWithDebug>
        )
      }
    >
      <Box
        sx={{
          p: isMaxPhone ? 1 : 2,
        }}
      >
        {organisationProfile.categories.length > 0 ? (
          <CategoriesChips categoryIds={organisationProfile.categories} />
        ) : (
          <Typography
            sx={{
              color: "grey.500",
            }}
          >
            {t("Not set", { ns: "Global" })}
          </Typography>
        )}
      </Box>
    </CardContainer>
  );
};
